import React from 'react'

const Cartnavbar = () => {
  return (
    <div className='w-full flex items-center justify-between shadow-sm shadow-amber-100 lg:px-20 md:px-12 px-4 bg-amber-50 py-4'>

        <h1 className='text-xl  font-bold px-4 py-2.5 '><span className='text-rose-600'>Apna App</span></h1>
        <div className='flex items-center '>
            <img src="/images/sprite-secure.png" className='w-12 h-12 p-2' alt="" />
            <h1 className='text-md font-medium text-gray-web'>100% SECURE </h1>
        </div>
    </div>
  )
}

export default Cartnavbar